import React from 'react';
import { TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Layers, FileText, LayoutGrid, ListChecks } from "lucide-react";

interface TabsNavigationProps {
    enhancedMatchesCount: number;
    matchGroupsCount: number;
}

export const TabsNavigation: React.FC<TabsNavigationProps> = ({
    enhancedMatchesCount,
    matchGroupsCount
}) => {
    return (
        <div className="flex items-center justify-between gap-4">
            <TabsList className="grid h-auto w-full grid-cols-2 gap-1 rounded-lg border bg-white/50 p-1 shadow-xs sm:flex sm:w-fit sm:gap-0 sm:p-0.5 dark:bg-slate-900/50">
                <TabsTrigger value="matches" className="w-full rounded-md px-2 py-2 text-xs font-medium data-[state=active]:bg-primary/10 data-[state=active]:text-primary sm:w-auto sm:px-4 sm:py-1.5">
                    <Layers className="h-3.5 w-3.5 mr-2" />
                    <span className="max-sm:truncate">Room Matches</span>
                    <span className="ml-1 sm:ml-2 bg-muted text-muted-foreground px-1 py-0 rounded-md text-[9px] font-bold">
                        {enhancedMatchesCount}
                    </span>
                </TabsTrigger>
                <TabsTrigger value="items" className="w-full rounded-md px-2 py-2 text-xs font-medium data-[state=active]:bg-primary/10 data-[state=active]:text-primary sm:w-auto sm:px-4 sm:py-1.5">
                    <ListChecks className="h-3.5 w-3.5 mr-2" />
                    <span className="max-sm:truncate">Line Item Matches</span>
                    <span className="ml-1 sm:ml-2 bg-muted text-muted-foreground px-1 py-0 rounded-md text-[9px] font-bold">
                        {matchGroupsCount}
                    </span>
                </TabsTrigger>
                <TabsTrigger value="organize" className="w-full rounded-md px-2 py-2 text-xs font-medium data-[state=active]:bg-primary/10 data-[state=active]:text-primary sm:w-auto sm:px-4 sm:py-1.5">
                    <LayoutGrid className="h-3.5 w-3.5 mr-2" />
                    Organize
                </TabsTrigger>
                <TabsTrigger value="summary" className="w-full rounded-md px-2 py-2 text-xs font-medium data-[state=active]:bg-primary/10 data-[state=active]:text-primary sm:w-auto sm:px-4 sm:py-1.5">
                    <FileText className="h-3.5 w-3.5 mr-2" />
                    Summary
                </TabsTrigger>
            </TabsList>
        </div>
    );
};
